import api from 'plugin/api';
import { API_URL } from 'types/const';
import isJSON from 'utils/isJSON';
import jsonToFormData from 'utils/json/toFormData';

/**
 * 원료 영양 성분 목록 조회
 * @param {Object} [params] 요청 데이터
 * @param {number[]} [params.factoryCodeSeqList] 선택한 공장
 * @param {string} [params.regYm] 월
 * @param {string} [params.rawMtrlCd] 원료 코드
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.sfms.rawMaterial.nutrition.list, { params });
}

/**
 * 원료 영양 성분 업로드 폼 다운로드
 * @return {Object} 응답 데이터
 */
async function requestDownload() {
  return api.get(API_URL.sfms.rawMaterial.nutrition.download, {
    responseType: 'arraybuffer'
  });
}

/**
 * 원료 영양 성분 업로드
 * @param {Object} data 요청 데이터
 * @param {number} data.factoryCodeSeq 공장
 * @param {string} data.regYm 월
 * @param {File} data.file xlsx 파일
 * @return {Object} 응답 데이터
 */
async function requestUpload(data) {
  if (isJSON(data)) {
    data = jsonToFormData(data);
  }

  return api.post(API_URL.sfms.rawMaterial.nutrition.upload, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

/**
 * 원료 영양 성분 BestMix 입력 확인
 * @param {Object} data 요청 데이터
 * @param {string} data.regYm 월
 * @return {Object} 응답 데이터
 */
async function requestExport(data) {
  return api.put(API_URL.sfms.rawMaterial.nutrition.export, data);
}

export { requestList, requestDownload, requestUpload, requestExport };
